import { Pipe, PipeTransform } from '@angular/core';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { MediaGroup } from '../../models/media/media-group.model';
import { CategorizedMediaGroup, GroupedFilesResult, GroupedResult } from '../../models/media/categorized-xray.model';

@Pipe({
  name: 'categroizedXraysPipe',
  pure: false,
})


export class CategroizedXraysPipe implements PipeTransform {
  transform(mediaGroups: MediaGroup[]): CategorizedMediaGroup[] {
    const excludedGroups = ['unknown', 'additional'];
    mediaGroups = mediaGroups
      .filter(
        (mediaGroup) =>
          !excludedGroups.find(
            (g) => g.toLowerCase() === mediaGroup.name.toLowerCase()
          )
      )
      .sort((a, b) => a.sortOrder - b.sortOrder);

    const sortOrders = [...new Set(mediaGroups.map(grp => grp.sortOrder))];

    let categorizedMediaGroups: CategorizedMediaGroup[] = [];

    for (let sortOrder of sortOrders) {
      let parallelMediaGroups: MediaGroup[] = mediaGroups.filter(x => x.sortOrder == sortOrder);
      const leftMediaGroup = parallelMediaGroups.find(x => x.leftOrRight == "Left");
      const rightMediaGroup = parallelMediaGroups.find(x => x.leftOrRight == "Right");

      const leftGroupFileResult = this.GetGroupResult(leftMediaGroup?.mediaCategories);
      const rightGroupFileResult = this.GetGroupResult(rightMediaGroup?.mediaCategories);
      if (leftMediaGroup) {
        leftMediaGroup.groupedResult = leftGroupFileResult;
      }
      if (rightMediaGroup) {
        rightMediaGroup.groupedResult = rightGroupFileResult;
      }

      const hasLeft = leftGroupFileResult.length > 0;
      const hasRight = rightGroupFileResult.length > 0;

      if (!hasLeft && !hasRight) {
        continue;
      }

      let categorizedMediaGroup = {
        leftMediaGroup: !leftMediaGroup ? ({} as MediaGroup) : leftMediaGroup,
        rightMediaGroup: !rightMediaGroup ? ({} as MediaGroup) : rightMediaGroup
      } as CategorizedMediaGroup;

      categorizedMediaGroups.push(categorizedMediaGroup);

    }

    return categorizedMediaGroups;
  }

  private GetGroupResult(mediaCategories: MediaCategory[]): GroupedResult[] {
    if (mediaCategories && mediaCategories.length > 0) {
      const groups = new Map<string, { left: StudyFile[], right: StudyFile[], sortOrder: number, isPrimaryColor: boolean, isOptional: boolean, isLeftOptional: boolean, isRightOptional: boolean }>();
      mediaCategories = mediaCategories.sort((a, b) => a.sortOrder - b.sortOrder);
      const distinctShortNames = Array.from(new Set(mediaCategories.map(item => item.shortName).filter(Boolean)));

      for (const shortName of distinctShortNames) {
        const categories = mediaCategories.filter(x => x.shortName === shortName);

        if (categories.length === 0) {
          continue;
        }

        const group = groups.get(shortName) ?? { left: [], right: [], sortOrder: null, isPrimaryColor: true, isOptional: false, isLeftOptional: true, isRightOptional: true };
        groups.set(shortName, group);

        for (const category of categories) {
          if (!group.sortOrder) {
            group.sortOrder = category.sortOrder;
          }

          if (!group.isOptional && !category.isRequired) {
            group.isOptional = true;
          }
          const side = category.leftOrRight || '';
          if (side.includes('Left')) {

            if (category.isRequired && group.isLeftOptional) {
              group.isLeftOptional = false;
            }

            if (category.studyFiles.length > 0) {
              group.left.push(...category.studyFiles);
            } else {
              if (category.isRequired) {
                group.left.push({ mediaCategoryId: category.id } as StudyFile);
              }
              if (group.isPrimaryColor && category.isRequired) {
                group.isPrimaryColor = false;
              }
            }

          }
          if (side.includes('Right')) {

            if (category.isRequired && group.isRightOptional) {
              group.isRightOptional = false;
            }

            if (category.studyFiles.length > 0) {
              group.right.push(...category.studyFiles);
            } else {
              if (category.isRequired) {
                group.right.push({ mediaCategoryId: category.id } as StudyFile);
              }
              if (group.isPrimaryColor && category.isRequired) {
                group.isPrimaryColor = false;
              }
            }

          }
        }
      }

      let tempResult: GroupedFilesResult[] = Array.from(groups.entries()).map(([shortName, { left, right, sortOrder, isPrimaryColor, isOptional, isLeftOptional, isRightOptional }]) => ({
        shortName,
        leftStudyFiles: left,
        rightStudyFiles: right,
        sortOrder,
        isPrimaryColor,
        isOptional,
        isLeftOptional,
        isRightOptional
      }));



      let result: GroupedResult[] = tempResult.map(({ sortOrder, ...rest }) => rest);

      return result;
    }
    return [];
  }

}
